export default {
    global_count: 0
}
